import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const tabs = [
  { key: "profile", label: "Mon profil", path: "/profiles/new" },
  { key: "orders", label: "Mes commandes", path: "/profiles/commandes" },
  { key: "avantages", label: "Mes avantages", path: "/profiles/avantages" },
];

/** Navigation commune aux pages profil / commandes / avantages. */
export function ProfileTabs({ active }: { active: string }) {
  return (
    <div className="grid w-full grid-cols-3 mb-8 gap-1 rounded-lg bg-muted p-1">
      {tabs.map((s) => (
        <Link
          key={s.key}
          to={s.path}
          className={cn(
            "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium transition-all",
            active === s.key
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {s.label}
        </Link>
      ))}
    </div>
  );
}

export default ProfileTabs;